import { IconWrapper } from '../runtime';
export default IconWrapper('flow_chart_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#1289DE"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#0475C5"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#239FF7"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#1289DE"
    }
  }), h("g", {
    "attrs": {
      "clip-path": "url(#clip0_913_639)"
    }
  }, [h("path", {
    "attrs": {
      "d": "M7.75264 3.10864L3.36133 7.49995L5.57112 9.70974L6.89694 8.38391L6.01298 7.49995L7.75264 5.76029L9.49401 7.50167L5.04797 11.9709L7.72284 14.6249H12.3858L15.0895 11.9423L12.3663 9.42726H11.8119L9.97437 11.2757V11.3023H11.633L12.3785 11.9908L11.6135 12.75H8.49521L7.70134 11.9622L9.97437 9.67738V9.67999L10.2256 9.42726H10.2232L12.1422 7.49823L7.75264 3.10864Z",
      "fill": "white"
    }
  })]), h("defs", [h("clipPath", {
    "attrs": {
      "id": "clip0_913_639"
    }
  }, [h("rect", {
    "attrs": {
      "width": "12.375",
      "height": "12.375",
      "fill": "white",
      "transform": "translate(3 3)"
    }
  })])])]);
});